import appInsights from '../AppInsights';

export default ({ getState }) => next => action => {
    if (loggedActions[action.type]) {
        const ev = loggedActions[action.type]({ state: getState(), payload: action.payload })
        appInsights.trackEvent(ev)
    }
    return next(action);
}

const loggedActions = {
    'IS_LOADED': ({ state }) => ({
        name: 'appInit',
        properties: {
            file: state.selection.file
        }
    }),
    'FETCH_DATA': () => ({
        name: 'btnSearchClicked'
    }),
    'SET_QUERY_ALL_VALUES': ({ state, payload }) => ({
        name: 'selectAllForVariable',
        properties: {
            variableName: payload,
            file: state.selection.file
        }
    }),
    'GET_PXQ': ({ payload }) => ({
        name: 'getPXQ',
        properties: {
            pxq: payload
        }
    }),
    'STUB_RIGTH': ({ payload }) => ({
        name: 'changeVariableOrder',
        properties: {
            action: 'stubToHeading',
            values: payload
        }
    }),
    'HEAD_LEFT': ({ payload }) => ({
        name: 'changeVariableOrder',
        properties: {
            action: 'headingToStub',
            values: payload
        }
    }),
    'STUB_UP': ({ payload }) => ({
        name: 'changeVariableOrder',
        properties: {
            action: 'stubUp',
            values: payload
        }
    }),
    'STUB_DOWN': ({ payload }) => ({
        name: 'changeVariableOrder',
        properties: {
            action: 'stubUp',
            values: payload
        }
    }),
    'HEAD_UP': ({ payload }) => ({
        name: 'changeVariableOrder',
        properties: {
            action: 'headingUp',
            values: payload
        }
    }),
    'HEADING_DOWN': ({ payload }) => ({
        name: 'changeVariableOrder',
        properties: {
            action: 'headingDown',
            values: payload
        }
    })

}